import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { supportEmail } from '@/configs';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneQuotaReachedNotice',
  props: {
    full: { type: Boolean, required: true },
    limit: { type: [Number, null], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const { t } = useI18n();
const visible = computed(() => props.full && props.limit !== null);

const __returned__ = { props, t, visible, get supportEmail() { return supportEmail } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})